var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.085,
    height: 26.313,
    viewBox: "0 0 35.085 26.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M31.8,30.813H3.289A3.289,3.289,0,0,1,0,27.524V7.789A3.289,3.289,0,0,1,3.289,4.5H31.8a3.289,3.289,0,0,1,3.289,3.289V27.524A3.289,3.289,0,0,1,31.8,30.813ZM7.675,8.337a3.837,3.837,0,1,0,3.837,3.837A3.837,3.837,0,0,0,7.675,8.337ZM4.386,26.428H30.7V18.753l-6-6a.822.822,0,0,0-1.163,0l-9.286,9.286-3.8-3.8a.822.822,0,0,0-1.163,0l-4.9,4.9Z",
    transform: "translate(0 -4.5)",
    fill: "#575555",
    opacity: 0.545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/IconGallery.8967482dea7acbeabd1ca46f86d04160.svg";
export { ForwardRef as ReactComponent };